/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateWidgetRequestBody,
  CreateWidgetRequestBody$Outbound,
  CreateWidgetRequestBody$outboundSchema,
} from "../components/createwidgetrequestbody.js";

export type CreateWidgetSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type CreateWidgetRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createWidgetRequestBody: CreateWidgetRequestBody;
};

/** @internal */
export type CreateWidgetSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateWidgetSecurity$outboundSchema: z.ZodMiniType<
  CreateWidgetSecurity$Outbound,
  CreateWidgetSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createWidgetSecurityToJSON(
  createWidgetSecurity: CreateWidgetSecurity,
): string {
  return JSON.stringify(
    CreateWidgetSecurity$outboundSchema.parse(createWidgetSecurity),
  );
}

/** @internal */
export type CreateWidgetRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateWidgetRequestBody: CreateWidgetRequestBody$Outbound;
};

/** @internal */
export const CreateWidgetRequest$outboundSchema: z.ZodMiniType<
  CreateWidgetRequest$Outbound,
  CreateWidgetRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createWidgetRequestBody: CreateWidgetRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createWidgetRequestBody: "CreateWidgetRequestBody",
    });
  }),
);

export function createWidgetRequestToJSON(
  createWidgetRequest: CreateWidgetRequest,
): string {
  return JSON.stringify(
    CreateWidgetRequest$outboundSchema.parse(createWidgetRequest),
  );
}
